import { find } from 'utils/dom'

export default function () {
	const Fundo = find("[js-page='fundos']")
	if (!Fundo) return

	console.log('Fundos')
}
